<template>
	<v-flex>
		<v-card align-start flat>
			<v-card-text>
				<v-form ref="edit_cc_form" v-model="cc.valid" lazy-validation>
					<v-layout wrap justify-space-between>
						<v-flex xs12 md12>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<p class="error--text font-weight-bold" v-html="errorMessage"></p>
								</v-flex>
							</v-layout>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											:value="`**** ${savedCardData['account_number_short']}`"
											label="CC Number"
											disabled
											class="co-text-field"
									></v-text-field>

								</v-flex>
								<v-flex py-0 md7 class="cc_icons">
									<v-img src="/checkout/assets/cc_visa.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
									<v-img src="/checkout/assets/cc_mc.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
									<v-img src="/checkout/assets/cc_amex.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
									<v-img src="/checkout/assets/cc_discover.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
								</v-flex>
							</v-layout>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="cc.cardholder_name"
											label="Cardholder Name"
											required
											:rules="rules.cardholder_name"
											class="co-text-field"
									></v-text-field>

								</v-flex>
							</v-layout>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="cc.expiration_date"
											label="Expiration Date"
											required
											return-masked-value
											:rules="rules.expiration_date"
											mask="##/##"
											class="co-text-field"
									></v-text-field>

								</v-flex>
							</v-layout>
						</v-flex>

						<v-flex xs12>
							<v-layout wrap justify-space-between>
								<v-flex xs12>

									<add-edit-shipping-address-form
											ref="billing_address"
											id="edit-billing-address"
											:address="savedCardData"
									></add-edit-shipping-address-form>

								</v-flex>

								<v-flex xs12 md5 py-0>
									<v-text-field
											v-model="cc.label"
											label="Credit Card Label"
											required
											:rules="rules.label"
											id="cc-label"
											name="cc-label"
											class="co-text-field"
									></v-text-field>
								</v-flex>

							</v-layout>
						</v-flex>

						<v-flex xs12>
							<v-layout wrap justify-space-between>
								<v-flex xs12>
									<v-btn @click="save" :loading="loading">Save</v-btn>
									<v-btn @click="cancel" :disabled="loading">Cancel</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-form>

			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
	import _ from 'lodash';
	import AddEditShippingAddressForm from './AddEditShippingAddressForm';

	export default {
		name: "EditCreditCardForm",

		components: {
			AddEditShippingAddressForm,
		},

		props: {
			errorMessage: {
				type: String,
				default: '',
			},
			invalidFields: {
				type: Array,
				default: [],
			},
			savedCardData: {
				type: Object,
				required: true,
			},
			loading: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			const self = this;

			return {
				cc: {
					valid: true,
					expiration_date: '',
					cardholder_name: '',
					label: '',
				},

				rules: {
					cardholder_name: [
						v => (typeof v === "string" && !!v.trim()) || 'Cardholder Name is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					label: [
						v => (typeof v === "string" && !!v.trim()) || 'Label is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					expiration_date: [
						v => (typeof v === "string" && !!v.trim()) || 'Expiration Date is required',
						v => /^(0[1-9]|1[0-2])\/([0-9]{4}|[0-9]{2})$/.exec(v) !== null || 'Invalid format.',
						v => {
							if (!v) {
								return 'Expiration Date is required';
							}

							const exp_date = v.split('/');
							let exp_month = parseInt(exp_date[0]) - 1, exp_year = parseInt(exp_date[1]);
							if (exp_year < 2000) {
								exp_year += 2000;
							}

							return (exp_month >= 0 && exp_year > 0 && (new Date(exp_year, exp_month)).getTime() >= (new Date()).getTime()) || 'Expiration Date is in past';
						}
					],
				},
			};
		},

		mounted() {
			this.cc.expiration_date = this.savedCardData['expiration_date'];
			this.cc.cardholder_name = this.savedCardData['cardholder'];
			this.cc.label = this.savedCardData['label'];

		},

		methods: {
			save() {
				const self = this;

				if (!self.$refs.edit_cc_form.validate()) {
					self.$refs.billing_address.fetch(); // to highlight invalid fields
					this.$vuetify.goTo(self.$refs.edit_cc_form);
					return null;
				}

				let billing_address = null;
				billing_address = self.$refs.billing_address.fetch();
				if (billing_address === null) {
					return null;
				}

				self.$emit('save', {
					...self.cc,
					billing_address,
				});
			},
			cancel() {
				this.$emit('cancel');
			}
		},
		computed: {
		}
	};
</script>

<style scoped lang="less">
	/deep/ .cc-field {
		max-height: 32px;
		width: 100%;

		iframe {
			height: 32px !important;
		}
	}

	.cc_icons {
		overflow: hidden;
		margin-left: 10px;

		.v-image {
			width: 32px;
			height: 20px;
			float: left;
			margin-top: 0;
			margin-bottom: 10px;
			margin-right: 10px;

			@media screen and (min-width: 600px) {
				margin-top: 22px;
				margin-bottom: 0;
			}
		}
	}
</style>